import serviceAfricaConsulting from "../../../../resources/images/service_africa_consulting.png";
import serviceElement from "../../../../resources/images/service_element.png";
import serviceGuild from "../../../../resources/images/service_guild.png";
import serviceManagedServiceProvider from "../../../../resources/images/service_msp.png";

import { Box, Grid, SxProps, Theme } from "@mui/material";
import { MoreLink } from "./moduels/MoreLink";

export const Service = () => {
  return (
    <Box sx={sx} className="Service">
      <Grid container className="Service-Title">
        <span className="Service-Title-Head">S</span>ERVICE
      </Grid>
      <Grid container className="Service-SubTitle">
        事業内容
      </Grid>
      <Box className="Service-Content">
        <Box className="Service-Content-ImagePc" component="img" alt="プログラマーズギルド" src={serviceGuild} />
        <Box className="Service-Content-Item">
          <Box className="Service-Content-Item-Ruby">プログラマーズギルド</Box>
          <Box className="Service-Content-Item-Title">
            Programmers
            <br className="Service-Content-Item-Title-BrSp" /> Guild
          </Box>
          <Box className="Service-Content-Item-SubTitle">チーム開発の請負サービス</Box>
          <Box className="Service-Content-Item-ImageSp" component="img" alt="プログラマーズギルド" src={serviceGuild} />
          <Box className="Service-Content-Item-Description">
            <span className="Service-Content-Item-Description-Strong">
              Programmers Guild（プログラマーズ・ギルド）は、優秀な副業人材を主体としたシステム開発の請負サービスです。
            </span>
            <br />
            現役で活躍するハイスキルなエンジニアをプロジェクトごとに最適なチームとして編成し、Web・業務システム、モバイルアプリ、インフラ構築など幅広い開発ニーズに対応します。
            <br />
            柔軟な体制とスピーディな対応力により、スタートアップから大企業まで、さまざまな課題に応じた高品質な技術支援を提供。
            <br />
            <span className="Service-Content-Item-Description-Strong">
              副業の枠を超えたプロフェッショナル集団が、貴社のプロジェクト成功を支援します。
            </span>
          </Box>
          <MoreLink href="https://programmers-guild.jp/" />
        </Box>
      </Box>
      <Box className="Service-Content">
        <Box
          className="Service-Content-ImagePc"
          component="img"
          alt="テクニカル アシスト サービス"
          src={serviceElement}
        />
        <Box className="Service-Content-Item">
          <Box className="Service-Content-Item-Ruby">テクニカル アシスト サービス</Box>
          <Box className="Service-Content-Item-Title">Technical Assist Service（TAS）</Box>
          <Box className="Service-Content-Item-SubTitle">専門的なエンジニアリングサービス</Box>
          <Box
            className="Service-Content-Item-ImageSp"
            component="img"
            alt="テクニカル アシスト サービス"
            src={serviceElement}
          />
          <Box className="Service-Content-Item-Description">
            <span className="Service-Content-Item-Description-Strong">
              テクニカル アシスト サービスは、企業のITプロジェクトを技術面から支援するサービスです。
            </span>
            <br />
            システム開発や運用保守、インフラ構築など、各工程に必要なスキルを持つエンジニアを柔軟に提供し、チームの一員として現場の課題解決に貢献します。業務内容に応じて最適な人材をアサインすることで、変化の多いプロジェクトにも迅速かつ的確に対応。
            <br />
            <span className="Service-Content-Item-Description-Strong">
              確かな技術力と対応力で、貴社のIT業務を支えます。
            </span>
          </Box>
          <MoreLink href="/tas" />
        </Box>
      </Box>
      <Box className="Service-Content">
        <Box
          className="Service-Content-ImagePc"
          component="img"
          alt="アドバンスドマネージドサービスプロバイダー"
          src={serviceManagedServiceProvider}
        />
        <Box className="Service-Content-Item">
          <Box className="Service-Content-Item-Ruby">アドバンスドマネージドサービスプロバイダー</Box>
          <Box className="Service-Content-Item-Title">Advanced Managed Service Provider（AMSP）</Box>
          <Box className="Service-Content-Item-SubTitle">副業人材を活用したハイレベルなMSPサービス</Box>
          <Box
            className="Service-Content-Item-ImageSp"
            component="img"
            alt="アドバンスドマネージドサービスプロバイダー"
            src={serviceManagedServiceProvider}
          />
          <Box className="Service-Content-Item-Description">
            <span className="Service-Content-Item-Description-Strong">
              副業として参画する優秀なエンジニアの力を活用し、従来の枠にとらわれない高品質なマネージドサービスを提供します。
            </span>
            <br />
            サーバ・ネットワークの監視、セキュリティ対策、クラウド最適化など、日々のIT運用を専門チームが一括対応。
            <br />
            社内では対応が難しい高度な技術課題にも、必要なときに必要なスキルを柔軟に投入することで迅速に対応可能です。
            <br />
            <span className="Service-Content-Item-Description-Strong">
              安定した運用と高い専門性を両立し、IT環境の最適化と業務効率化を力強く支援します。
            </span>
          </Box>
          <MoreLink href="/amsp" />
        </Box>
      </Box>
      <Box className="Service-Content">
        <Box
          className="Service-Content-ImagePc"
          component="img"
          alt="アフリカコンサルティングサービス"
          src={serviceAfricaConsulting}
        />
        <Box className="Service-Content-Item">
          <Box className="Service-Content-Item-Ruby">アフリカコンサルティングサービス</Box>
          <Box className="Service-Content-Item-Title">Africa Consulting Service（ACS）</Box>
          <Box className="Service-Content-Item-SubTitle">アフリカ進出コンサルティングサービス</Box>
          <Box
            className="Service-Content-Item-ImageSp"
            component="img"
            alt="アフリカコンサルティングサービス"
            src={serviceAfricaConsulting}
          />
          <Box className="Service-Content-Item-Description">
            <span className="Service-Content-Item-Description-Strong">
              アフリカ進出コンサルティングは、成長著しいアフリカ市場への展開を目指す企業を支援する専門サービスです。
            </span>
            <br />
            現地の市場調査、進出戦略の立案、法人設立、パートナー選定、運営支援まで一貫してサポート。
            <br />
            多国籍・多文化な環境に対応し、実践的な知見とネットワークを活かして、現地でのビジネスをスムーズに立ち上げます。
            <br />
            <span className="Service-Content-Item-Description-Strong">
              リスクを抑えながら、確実な市場参入を実現します。
            </span>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const sx: SxProps<Theme> = (theme) => ({
  "&.Service": {
    width: "100%",
    padding: "64px 0 92px",
  },
  ".Service-Title": {
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Avenir Next",
    fontWeight: 500,
    fontSize: {
      md: "64px",
      xs: "40px",
    },
    lineHeight: "88px",
    letterSpacing: "0.15em",
  },
  ".Service-Title-Head": {
    color: "#22A1B9",
    fontWeight: 700,
  },
  ".Service-SubTitle": {
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
    fontSize: {
      md: "16px",
      xs: "14px",
    },
    lineHeight: {
      md: "24x",
      xs: "20px",
    },
    letterSpacing: "1px",
  },
  ".Service-Content": {
    justifyContent: {
      md: "flex-start",
      xs: "center",
    },
    marginTop: {
      md: "100px",
      xs: "60px",
    },
    display: "flex",
    flexDirection: "row-reverse",
    "&:nth-child(odd)": {
      flexDirection: "row",
    },
  },
  ".Service-Content-ImagePc": {
    display: {
      md: "flex",
      xs: "none",
    },
    maxWidth: "740px",
    objectFit: "contain",
    objectPosition: "top",
  },
  ".Service-Content-Item": {
    margin: {
      md: "0px 120px",
      xs: "0px 32px",
    },
  },
  ".Service-Content-Item-Ruby": {
    fontWeight: 700,
    fontSize: {
      md: "16px",
      xs: "14px",
    },
    lineHeight: {
      md: "22px",
      xs: "20px",
    },
  },
  ".Service-Content-Item-Title": {
    fontWeight: 600,
    fontSize: {
      md: "46px",
      xs: "42px",
    },
    lineHeight: {
      md: "66px",
      xs: "48px",
    },
    letterSpacing: "0.05em",
    color: "#22A1B9",
  },
  ".Service-Content-Item-Title-BrSp": {
    display: {
      md: "none",
      xs: "block",
    },
  },
  ".Service-Content-Item-SubTitle": {
    fontWeight: 700,
    fontSize: {
      md: "24px",
      xs: "20px",
    },
    lineHeight: {
      md: "33px",
      xs: "27px",
    },
  },
  ".Service-Content-Item-ImageSp": {
    display: {
      md: "none",
      xs: "flex",
    },
    width: "100%",
    marginTop: "8px",
  },
  ".Service-Content-Item-Description": {
    maxWidth: {
      md: "530px",
      xs: "100%",
    },
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: {
      md: "30px",
      xs: "35px",
    },
    marginTop: "33px",
  },
  ".Service-Content-Item-Description-Strong": {
    fontWeight: 600,
  },
});
